//styling
import './Styles.scss';
import './clusterRow.css';

const ClustersListPageHeader = () => {
  return (
    <div className='wcsWrappper'>
      <div className='wcsBox'>
        <p>
          This is the legacy console for the Weaviate Cloud Service. In order to
          make use of our latest features and create sandboxes as well as
          managed clusters, please use the{' '}
          <a href='https://console.weaviate.cloud/'>new console</a> instead by
          visiting:
        </p>
        <a href='https://console.weaviate.cloud/' className='wcsLinkButton'>
          New Weaviate Console
        </a>
      </div>
    </div>
  );
};

export default ClustersListPageHeader;
